import { ViewportScroller } from '@angular/common';
import { ChangeDetectorRef, Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { Subject, takeUntil, timer } from 'rxjs';
import { SmartTireService } from 'src/app/services/feature/smartTire/smart-tire.service';

@Component({
  selector: 'app-kbsmartire-email',
  templateUrl: './kbsmartire-email.component.html',
  styleUrl: './kbsmartire-email.component.scss',
  standalone: false
})
export class KbsmartireEmailComponent {
  captchaResolved: boolean = false;
  private destroy$ = new Subject<void>();
  private timeout?: ReturnType<typeof setTimeout> | null = null;// Store the timeout ID
  constructor(private SmartTireService: SmartTireService, private cdr: ChangeDetectorRef,
    public dialogRef: MatDialogRef<KbsmartireEmailComponent>,
    private globalmsgService: GlobalMessageService,
    private viewPortScroller: ViewportScroller
  ) { }

  emailForm = new FormGroup({
    fName: new FormControl(null, { validators: Validators.required }),
    lName: new FormControl(null, { validators: Validators.required }),
    emailId: new FormControl(null, { validators: Validators.required }),
    recaptcha: new FormControl(null, [Validators.required]),
  });
  get form() {
    return this.emailForm.controls;
  }
  ngOnInit() {
    this.SmartTireService.vistInfoData$.pipe(takeUntil(this.destroy$)).subscribe(data => {
      console.log(data);
      if (data != null) {
        this.emailForm.patchValue({
          fName: data.firstName || null,
          lName: data.lastName || null,
          emailId: data.eMail || null,
        });
      }
    })
    setTimeout(() => { document.querySelector('.cdk-global-overlay-wrapper')?.removeAttribute('popover') }, 0);
  }
  emailResult() {
    if (this.emailForm.valid) {
      this.SmartTireService.popUpData$.next(this.emailForm.value);
      this.SmartTireService.postAPI().pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
        if (x === 'Success') {
          this.dialogRef.close({
            status: 'Success',
            message: 'common.smartire_calculator_formSubmit_success'
          });
        }
      });
    }
    else {
      this.emailForm.markAllAsTouched();
    }
  }

  checkCaptcha(captchaResponse: string) {
    this.captchaResolved = captchaResponse && captchaResponse.length > 0 ? true : false;
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
}
